import { createSlice } from '@reduxjs/toolkit'

import { profileApi } from '@core/app/api/profileApi'
import { newProfileApi } from '@core/app/api/v2/newProfileApi'
import { RootState } from '@core/app/store/store'
import {
    AuthMethods,
    ContactPreferencesData,
    DeletionRequestData,
    LastLoginData,
    LocaleItem,
    NewProfileData,
    NewProfileFile,
    PhonesData,
    ProfileFieldsDataSettings,
    TermsData,
} from '@core/app/types/v2/newProfile'


interface PayslipsState {
    loading: boolean
}

const initialState: PayslipsState = {
    loading: false,
}

const payslipsSlice = createSlice({
    name: 'payslips',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder.addMatcher(newProfileApi.endpoints.getProfileData.matchFulfilled, (state, action) => {
            const payload = action.payload

            state.loading = false
        })
        builder.addMatcher(newProfileApi.endpoints.getProfileData.matchPending, (state) => {
            state.loading = true
        })
        builder.addMatcher(newProfileApi.endpoints.getProfileData.matchRejected, (state) => {
            state.loading = false
        })
    },
})

export const {  } = payslipsSlice.actions
export default payslipsSlice.reducer
